import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';
import PlainStudentCard from '@components/Registration/Views/PlainView/PlainStudentCard';
import {memo} from 'react';
import {MockPlainStudentCard} from '@components/Registration/Views/PlainView/PlainStudentCard/PlainStudentCard';
import {useWindowSize} from 'react-use';
import useMeasureCols from '@hooks/useMeasureCols';
import {useTransition} from 'react-spring';


export const ViewContainer = styled.div<{ rows: number }>`
  padding:20px var(--padding) calc(var(--footer-height) + 20px) var(--padding);
  position: relative;
  display: grid;
  grid-template-columns: repeat(${({ rows }) => rows}, 1fr);
  grid-gap: 20px 40px;
  justify-content: space-between;
  height: 100%;
  overflow-y: auto;

  ${mq(Devices.tablet)} {
    grid-template-columns: 1fr;
  }

  > div:nth-of-type(n) {
    cursor: pointer;
    width: 100%;
  }

  > div:nth-of-type(4n + 1) {
    margin-left: 0;
  }
`;

const mockEntries = Array(4).fill('');

export const SmallCardView = ({ onStudentSelected, students }) => {
  const { width, height } = useWindowSize();

  const cols = useMeasureCols(326, 20);

  const transitions = useTransition(
    students.data?.map((data) => ({
      ...data,
    })),
    {
      opacity: 1,
      key: (item) => item?.sis_id,
      from: { opacity: 0 },
      leave: { opacity: 0 },
    },
  );

  return (
    <ViewContainer rows={cols}>
      {students.data?.length > 0
        ? transitions((style, item, _, index) => (
            <PlainStudentCard style={style} attendance={true} content={item} onClick={onStudentSelected} index={index} key={index} />
          ))
        : mockEntries.map((_, i) => <MockPlainStudentCard key={i} />)}
    </ViewContainer>
  );
};

export default memo(SmallCardView);
